var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedstepsRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-623"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.74,
    y: 95.99,
    width: 268.67,
    height: 221.85,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.74,
    y: 100.69,
    width: 264.36,
    height: 212.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.15 252.83 331.15 177.71 323.34 177.71 323.34 167.78 305.78 159.57 305.78 149.41 302.86 149.41 302.86 177.71 299.93 177.71 299.93 252.83 296.03 252.83 296.03 213.81 287.25 213.81 287.25 193.32 284.32 193.32 284.32 252.83 277.49 252.83 277.49 230.39 272.61 230.39 272.61 224.54 261.88 224.54 261.88 204.05 256.02 204.05 256.02 190.39 249.2 190.39 249.2 169.9 246.27 169.9 246.27 190.39 239.44 190.39 239.44 204.05 233.59 204.05 233.59 224.54 222.85 224.54 222.85 230.39 217.98 230.39 217.98 252.83 212.12 252.83 212.12 224.54 201.39 224.54 201.39 162.1 198.46 162.1 198.46 155.27 175.05 155.27 175.05 162.1 170.17 162.1 170.17 206.98 150.66 206.98 150.66 211.85 143.83 211.85 143.83 214.78 150.66 214.78 150.66 232.34 130.17 232.34 130.17 173.8 126.27 173.8 126.27 162.1 116.51 162.1 116.51 117.22 113.58 117.22 113.58 162.1 106.75 162.1 106.75 173.8 68.74 173.8 68.74 313.32 333.1 313.32 333.1 252.83 331.15 252.83",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 223.21,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 227.84,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 213.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 223.21,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.44,
    y: 227.84,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 213.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 218.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 227.84,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.22,
    y: 246.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 237.11,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 241.74,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 246.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 251.01,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.61,
    y: 269.55,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 213.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 218.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 232.47,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 237.11,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 241.74,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 246.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 251.01,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 269.55,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 213.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 218.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 223.21,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 227.84,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 232.47,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 237.11,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 241.74,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 246.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 251.01,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.39,
    y: 255.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 213.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 218.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 232.47,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 237.11,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 241.74,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.78,
    y: 246.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 176.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 181.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 186.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 190.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 195.4,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 200.03,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 204.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 209.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 213.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 218.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 232.47,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 237.11,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 241.74,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 164.83,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 169.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 174.1,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 192.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 164.83,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 169.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 174.1,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 192.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 164.83,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 169.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 174.1,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 192.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 164.83,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 169.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 174.1,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 201.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.78,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 164.83,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 169.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 174.1,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 201.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 206.54,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 257.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 164.83,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 169.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 174.1,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 201.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 206.54,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 257.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.56,
    y: 262.15,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.79,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.57,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 272.8,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.96,
    y: 277.43,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 272.8,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 277.43,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 282.07,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 180.12,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 184.75,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 189.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 194.02,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 198.65,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 203.29,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 263.53,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 268.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 272.8,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 277.43,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.36,
    y: 282.07,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 180.12,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 184.75,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 189.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 194.02,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 198.65,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 203.29,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.75,
    y: 263.53,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 180.12,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 184.75,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 189.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 194.02,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 198.65,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 203.29,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.14,
    y: 263.53,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 180.12,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 184.75,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 189.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 194.02,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 198.65,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 203.29,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 180.12,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 184.75,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 189.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 194.02,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 198.65,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 203.29,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 180.12,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 184.75,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 189.38,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 194.02,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 198.65,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 203.29,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 207.92,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 212.56,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.32,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 192.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 201.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 206.54,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 252.88,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 262.15,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 266.78,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 271.42,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 276.05,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.05,
    y: 280.69,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 192.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 201.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 206.54,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 276.05,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 280.69,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 178.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 183.37,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 188,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 192.64,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 197.27,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 201.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 206.54,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 257.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 262.15,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 266.78,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 271.42,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.83,
    y: 280.69,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 252.88,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 257.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 262.15,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 266.78,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 276.05,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 280.69,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 285.32,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 289.95,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 299.22,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 303.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.42,
    y: 308.49,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 252.88,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 257.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 262.15,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 266.78,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 280.69,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 285.32,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 294.59,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 299.22,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 303.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.81,
    y: 308.49,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 211.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 215.81,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 220.44,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 225.08,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 229.71,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 234.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 238.98,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 243.61,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 248.25,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 252.88,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 257.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 262.15,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 266.78,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 271.42,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 280.69,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 289.95,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 294.59,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 299.22,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 303.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 308.49,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 237.6,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 242.23,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 246.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 251.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 256.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 260.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 274.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 279.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 283.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 288.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 293.21,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 297.84,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.53,
    y: 302.48,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 237.6,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 242.23,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 246.86,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 251.5,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 256.13,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 260.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 274.67,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 279.3,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 283.94,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 288.57,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 293.21,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 297.84,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 307.11,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 263.53,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 272.8,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 277.43,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 282.07,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 286.7,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 291.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 295.97,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 300.6,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.78,
    y: 305.24,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 217.19,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 221.82,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 226.46,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 231.09,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 235.73,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 240.36,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 244.99,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 249.63,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 254.26,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 258.9,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 263.53,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 268.17,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 272.8,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 277.43,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 282.07,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 286.7,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 291.34,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 295.97,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 300.6,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.17,
    y: 305.24,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 235.24,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 239.87,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 244.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 249.14,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 253.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 258.41,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 263.04,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 267.68,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 272.31,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.15,
    y: 276.95,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 235.24,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 239.87,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 244.51,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 249.14,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 253.77,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 258.41,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 263.04,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 267.68,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 272.31,
    width: 2.76,
    height: 2.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.42,
    y: 96.5,
    width: 4.64,
    height: 221.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.14,
    y: 96.5,
    width: 4.64,
    height: 221.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.87,
    y: 96.5,
    width: 4.64,
    height: 221.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,128s.86-5.68-3.29-9.33-3.78-5.81-2.6-6.1,2.28,3.37,4.11,4.37c0,0,0-5.2-1.8-7.11s-2.82-6.84-1.06-6.93,1.94,2.93,2.31,5.07A17.89,17.89,0,0,0,421,113.1s.38-4.65,1.58-6.56-2-6.29-.77-8.2,3.42,1.73,3.24,5.83-2.92,8.48-2.28,12.76c0,0,1.21-3,2.29-3.28s2.18-2.26,2.9-3,1.65,1.81,0,4.18-5.83,8.71-5.19,13.84Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.53,125.41l-1.36,8.52a4.33,4.33,0,0,0,4.28,5h1.45a4.34,4.34,0,0,0,4.28-5l-1.36-8.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.08,
    y: 135.8,
    width: 85.99,
    height: 4.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.49,
    y: 117.62,
    width: 4.23,
    height: 18.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.94,
    y: 117.62,
    width: 4.23,
    height: 18.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.73,
    y: 117.39,
    width: 4.23,
    height: 18.18,
    transform: "translate(-15.6 70.6) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.73,
    y: 120.01,
    width: 4.23,
    height: 15.78,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.45,
    y: 120.01,
    width: 4.23,
    height: 15.78,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.99,
    y: 120.01,
    width: 4.23,
    height: 15.78,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.26,
    y: 119.74,
    width: 4.23,
    height: 15.78,
    transform: "translate(-18.46 87.06) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.5,
    y: 116.72,
    width: 2.11,
    height: 19.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.66,
    y: 116.72,
    width: 2.11,
    height: 19.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.08,
    y: 172.62,
    width: 85.99,
    height: 4.93,
    transform: "translate(792.14 350.17) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.42,
    y: 154.44,
    width: 4.23,
    height: 18.18,
    transform: "translate(865.07 327.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.97,
    y: 154.44,
    width: 4.23,
    height: 18.18,
    transform: "translate(824.17 327.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.18,
    y: 154.21,
    width: 4.23,
    height: 18.18,
    transform: "matrix(-0.99, -0.17, 0.17, -0.99, 741.23, 390.01)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.18,
    y: 156.83,
    width: 4.23,
    height: 15.78,
    transform: "translate(854.59 329.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.46,
    y: 156.83,
    width: 4.23,
    height: 15.78,
    transform: "translate(835.15 329.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.92,
    y: 156.83,
    width: 4.23,
    height: 15.78,
    transform: "translate(786.08 329.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.65,
    y: 156.56,
    width: 4.23,
    height: 15.78,
    transform: "translate(764.23 412.78) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.52,
    y: 153.53,
    width: 2.11,
    height: 19.08,
    transform: "translate(845.16 326.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.37,
    y: 153.53,
    width: 2.11,
    height: 19.08,
    transform: "translate(794.85 326.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.29,
    y: 158.23,
    width: 20.61,
    height: 14.23,
    transform: "translate(745.18 330.68) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-623"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-623",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-623"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.93,341.89c.21,1.47-3.78,2.44-7,3,.27,2.67,2,5.37,4.5,7.88,3.08-1.73,7.49-4,8.3-3.47s-3.63,3.53-6.45,5.24a57.69,57.69,0,0,0,6.39,4.84c1.38-1.29,3-2.42,4-1.81s.73,2.64.23,4.42c3.36,2,5.87,3.15,5.87,3.15a68.29,68.29,0,0,0,2.25-9.53c-.17-.34-.34-.67-.49-1-.55-1.25,0-1.78.87-2a32.92,32.92,0,0,0,.06-6.87c-3.8-.79-8.42-2.27-6.69-4.55,1-1.37,3-1.52,4.94-1.18a7.4,7.4,0,0,0-.94-1.28c-6.91-7.62-11.73,0-11.73,0-4-3.35-9.66-2.44-10.88,2.79C395.35,340.93,399.67,340.07,399.93,341.89Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.93,341.89c.21,1.47-3.78,2.44-7,3,.27,2.67,2,5.37,4.5,7.88,3.08-1.73,7.49-4,8.3-3.47s-3.63,3.53-6.45,5.24a57.69,57.69,0,0,0,6.39,4.84c1.38-1.29,3-2.42,4-1.81s.73,2.64.23,4.42c3.36,2,5.87,3.15,5.87,3.15a68.29,68.29,0,0,0,2.25-9.53c-.17-.34-.34-.67-.49-1-.55-1.25,0-1.78.87-2a32.92,32.92,0,0,0,.06-6.87c-3.8-.79-8.42-2.27-6.69-4.55,1-1.37,3-1.52,4.94-1.18a7.4,7.4,0,0,0-.94-1.28c-6.91-7.62-11.73,0-11.73,0-4-3.35-9.66-2.44-10.88,2.79C395.35,340.93,399.67,340.07,399.93,341.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.56,397.87l-1-.08c0-.51,4.09-51.52-7.35-56.33a3.85,3.85,0,0,0-3.47.09c-4.14,2.15-6.12,11.08-6.14,11.17l-1-.21c.08-.39,2.1-9.48,6.65-11.85a4.89,4.89,0,0,1,4.32-.12C412.7,345.62,408.73,395.74,408.56,397.87Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,396.77c-.2-2.3-4.88-56.27,3.86-62,2.1-1.37,4-1.66,5.55-.86,4.13,2.08,4.67,10.91,4.69,11.28l-1,.06c0-.09-.52-8.63-4.14-10.45-1.24-.62-2.78-.36-4.55.81-8.24,5.4-3.46,60.51-3.41,61.07Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.31,401.13c-.06-1.75-1.5-43.07,6.46-46.68a5.55,5.55,0,0,1,4.73,0c5.46,2.4,8.83,12.57,9,13l-1,.31c0-.11-3.37-10.19-8.43-12.41a4.54,4.54,0,0,0-3.91,0c-6.1,2.77-6.3,33.95-5.87,45.74Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,399.24l-1-.11c1.4-12.3,4.08-45.06-.3-49a1.73,1.73,0,0,0-1.79-.55c-2.94,1.12-4.73,11.78-5.17,15.79l-1-.11c.17-1.54,1.77-15.07,5.8-16.62a2.66,2.66,0,0,1,2.81.74C414.32,354.46,409.5,397.42,409.29,399.24Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.6 375.93 428.53 375.93 425.53 416.18 395.6 416.18 392.6 375.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.49,361.16c-.37,1-3.16.21-5.35-.57-.75,1.74-.58,4,.07,6.41,2.5,0,6,.08,6.31.7s-3.45.93-5.77,1A40.05,40.05,0,0,0,395,373.9c1.29-.32,2.68-.47,3.06.24s-.45,1.88-1.37,2.81c1.4,2.36,2.55,3.95,2.55,3.95a48.12,48.12,0,0,0,4.65-5.11c0-.26,0-.53.05-.8.09-1,.6-1.1,1.21-.91a23.9,23.9,0,0,0,2.39-4.21c-2.07-1.8-4.42-4.29-2.57-5.1,1.12-.49,2.35.07,3.46,1a6.74,6.74,0,0,0-.14-1.11c-1.66-7.07-7.24-4-7.24-4-1.33-3.44-5.12-4.82-7.67-2C395,359,398,360,397.49,361.16Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.49,361.16c-.37,1-3.16.21-5.35-.57-.75,1.74-.58,4,.07,6.41,2.5,0,6,.08,6.31.7s-3.45.93-5.77,1A40.05,40.05,0,0,0,395,373.9c1.29-.32,2.68-.47,3.06.24s-.45,1.88-1.37,2.81c1.4,2.36,2.55,3.95,2.55,3.95a48.12,48.12,0,0,0,4.65-5.11c0-.26,0-.53.05-.8.09-1,.6-1.1,1.21-.91a23.9,23.9,0,0,0,2.39-4.21c-2.07-1.8-4.42-4.29-2.57-5.1,1.12-.49,2.35.07,3.46,1a6.74,6.74,0,0,0-.14-1.11c-1.66-7.07-7.24-4-7.24-4-1.33-3.44-5.12-4.82-7.67-2C395,359,398,360,397.49,361.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,365.94a14.5,14.5,0,0,0-3.28.69,7.65,7.65,0,0,1-.49-2.37c-.22-7.25,5-4.19,7.7-6.32a5.92,5.92,0,0,1,4.59-1.44,11,11,0,0,0-.62,1.24,1.13,1.13,0,0,0,.88,1.55,3.3,3.3,0,0,0,2-.24,4.8,4.8,0,0,0,.52-.36,9.33,9.33,0,0,1,1,2.42,14.08,14.08,0,0,1,.47,3.1,9.84,9.84,0,0,0-1.21.34,1.13,1.13,0,0,0-.46,1.72,5.15,5.15,0,0,0,1.5,1.05,17,17,0,0,1-.91,3.4l-.37,0c-.27.06-.53.12-.79.2a2.5,2.5,0,0,0-.43.16,1.11,1.11,0,0,0-.25,1.92,3.71,3.71,0,0,0,.54.33,8,8,0,0,1-2.87,2.9,31.08,31.08,0,0,1-3.05-1.61c.21-.29.43-.58.63-.88a1.74,1.74,0,0,0,.31-1.14,1.55,1.55,0,0,0-1.73-1.33,1.56,1.56,0,0,0-1,.59c-.24.35-.5.69-.77,1a19.11,19.11,0,0,1-3.68-3.57l.11,0a11,11,0,0,1,2.05-.34,1.54,1.54,0,1,0-.4-3.06Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,365.94a14.5,14.5,0,0,0-3.28.69,7.65,7.65,0,0,1-.49-2.37c-.22-7.25,5-4.19,7.7-6.32a5.92,5.92,0,0,1,4.59-1.44,11,11,0,0,0-.62,1.24,1.13,1.13,0,0,0,.88,1.55,3.3,3.3,0,0,0,2-.24,4.8,4.8,0,0,0,.52-.36,9.33,9.33,0,0,1,1,2.42,14.08,14.08,0,0,1,.47,3.1,9.84,9.84,0,0,0-1.21.34,1.13,1.13,0,0,0-.46,1.72,5.15,5.15,0,0,0,1.5,1.05,17,17,0,0,1-.91,3.4l-.37,0c-.27.06-.53.12-.79.2a2.5,2.5,0,0,0-.43.16,1.11,1.11,0,0,0-.25,1.92,3.71,3.71,0,0,0,.54.33,8,8,0,0,1-2.87,2.9,31.08,31.08,0,0,1-3.05-1.61c.21-.29.43-.58.63-.88a1.74,1.74,0,0,0,.31-1.14,1.55,1.55,0,0,0-1.73-1.33,1.56,1.56,0,0,0-1,.59c-.24.35-.5.69-.77,1a19.11,19.11,0,0,1-3.68-3.57l.11,0a11,11,0,0,1,2.05-.34,1.54,1.54,0,1,0-.4-3.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.24,341a10.15,10.15,0,0,1,2-1.08,5.31,5.31,0,0,0-.79-1.46c-3.06-3.9-4.44,0-6.82.06a4,4,0,0,0-3,1.26,6.74,6.74,0,0,1,.87.38.77.77,0,0,1,.22,1.2,2.15,2.15,0,0,1-1.17.76,2.09,2.09,0,0,1-.43,0,6.53,6.53,0,0,0,.54,1.71,9.1,9.1,0,0,0,1.11,1.84,6.33,6.33,0,0,1,.79-.36.78.78,0,0,1,1,.71,3.8,3.8,0,0,1-.32,1.21,11.29,11.29,0,0,0,2,1.38l.21-.13c.17-.09.33-.17.5-.24a1.82,1.82,0,0,1,.3-.11.8.8,0,0,1,.74.16.79.79,0,0,1,.23.74,2.8,2.8,0,0,1-.13.41,5.37,5.37,0,0,0,2.78.26,20,20,0,0,0,.89-2.18l-.72-.19a1.15,1.15,0,0,1-.66-.46,1.05,1.05,0,0,1-.14-.79,1.1,1.1,0,0,1,.46-.67,1.13,1.13,0,0,1,.8-.14,8.29,8.29,0,0,0,.86.21,13,13,0,0,0,.36-3.49l-.07,0a7.11,7.11,0,0,0-1.22.72,1.06,1.06,0,0,1-1.14-1.78Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.24,341a10.15,10.15,0,0,1,2-1.08,5.31,5.31,0,0,0-.79-1.46c-3.06-3.9-4.44,0-6.82.06a4,4,0,0,0-3,1.26,6.74,6.74,0,0,1,.87.38.77.77,0,0,1,.22,1.2,2.15,2.15,0,0,1-1.17.76,2.09,2.09,0,0,1-.43,0,6.53,6.53,0,0,0,.54,1.71,9.1,9.1,0,0,0,1.11,1.84,6.33,6.33,0,0,1,.79-.36.78.78,0,0,1,1,.71,3.8,3.8,0,0,1-.32,1.21,11.29,11.29,0,0,0,2,1.38l.21-.13c.17-.09.33-.17.5-.24a1.82,1.82,0,0,1,.3-.11.8.8,0,0,1,.74.16.79.79,0,0,1,.23.74,2.8,2.8,0,0,1-.13.41,5.37,5.37,0,0,0,2.78.26,20,20,0,0,0,.89-2.18l-.72-.19a1.15,1.15,0,0,1-.66-.46,1.05,1.05,0,0,1-.14-.79,1.1,1.1,0,0,1,.46-.67,1.13,1.13,0,0,1,.8-.14,8.29,8.29,0,0,0,.86.21,13,13,0,0,0,.36-3.49l-.07,0a7.11,7.11,0,0,0-1.22.72,1.06,1.06,0,0,1-1.14-1.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,348.21c-.21,1.47,3.78,2.44,7,3-.27,2.67-2,5.37-4.49,7.89-3.09-1.74-7.49-4-8.31-3.48s3.63,3.53,6.45,5.25a59,59,0,0,1-6.39,4.84c-1.38-1.29-3-2.43-4-1.81s-.73,2.63-.23,4.42c-3.36,1.95-5.87,3.14-5.87,3.14a68.29,68.29,0,0,1-2.25-9.53c.17-.33.34-.67.5-1,.54-1.25,0-1.78-.88-2a33.53,33.53,0,0,1-.06-6.86c3.8-.8,8.42-2.27,6.69-4.55-1-1.37-2.95-1.53-4.94-1.19a7.87,7.87,0,0,1,.94-1.27c6.91-7.62,11.73,0,11.73,0,4-3.35,9.67-2.45,10.89,2.79C401.55,347.26,397.23,346.4,397,348.21Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,348.21c-.21,1.47,3.78,2.44,7,3-.27,2.67-2,5.37-4.49,7.89-3.09-1.74-7.49-4-8.31-3.48s3.63,3.53,6.45,5.25a59,59,0,0,1-6.39,4.84c-1.38-1.29-3-2.43-4-1.81s-.73,2.63-.23,4.42c-3.36,1.95-5.87,3.14-5.87,3.14a68.29,68.29,0,0,1-2.25-9.53c.17-.33.34-.67.5-1,.54-1.25,0-1.78-.88-2a33.53,33.53,0,0,1-.06-6.86c3.8-.8,8.42-2.27,6.69-4.55-1-1.37-2.95-1.53-4.94-1.19a7.87,7.87,0,0,1,.94-1.27c6.91-7.62,11.73,0,11.73,0,4-3.35,9.67-2.45,10.89,2.79C401.55,347.26,397.23,346.4,397,348.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-623"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 363.14,
    width: 25.85,
    height: 18.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19,359v57.13h35.67V359ZM97,375.92H85.63v-6.84a2.88,2.88,0,0,1,2.88-2.88h5.58A2.88,2.88,0,0,1,97,369.08Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19,359v57.13h35.67V359ZM97,375.92H85.63v-6.84a2.88,2.88,0,0,1,2.88-2.88h5.58A2.88,2.88,0,0,1,97,369.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.19,
    y: 359.05,
    width: 15.3,
    height: 57.13,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.27,
    y: 356.03,
    width: 37.43,
    height: 5.52,
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.27,
    y: 356.03,
    width: 17.27,
    height: 5.52,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-623"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.2,
    y: 112.57,
    width: 199.02,
    height: 188.44,
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.2,
    y: 112.57,
    width: 199.02,
    height: 188.44,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.2,
    y: 112.57,
    width: 199.02,
    height: 9.59,
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.64,
    y: 122.16,
    width: 6.58,
    height: 179.02,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.02,
    y: 126.4,
    width: 3.96,
    height: 24.94,
    rx: 1.68,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.98 144.25 408.51 144.25 409.08 137.47 402.4 137.47 402.98 144.25",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.88 142.46 387.93 141.21 390.65 137.84 390.65 135.62 384.14 135.62 384.14 144.25 390.65 144.25 390.65 140.22 389.09 142.15 387.88 142.46",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.06,
    cy: 140.11,
    r: 13.08,
    transform: "translate(-24.36 221.39) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.06,
    cy: 140.11,
    r: 11.08,
    transform: "translate(60.1 356.15) rotate(-76.72)",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.41,135.21v8.4h-1.94v-6.84h-1.68v-1.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.65,
    y: 130.29,
    width: 101.9,
    height: 19.64,
    rx: 3.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.78,
    y: 91.16,
    width: 15.64,
    height: 97.9,
    rx: 1.18,
    transform: "translate(463.7 -183.49) rotate(90)",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.27,139.54A3.54,3.54,0,0,1,295,136a3.46,3.46,0,0,1,2.66,1.09l-.65.63a2.59,2.59,0,0,0-2-.83,2.69,2.69,0,1,0,0,5.38,2.6,2.6,0,0,0,2-.84l.65.63a3.47,3.47,0,0,1-2.67,1.1A3.54,3.54,0,0,1,291.27,139.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,139.54a3.72,3.72,0,1,1,3.73,3.58A3.56,3.56,0,0,1,298.35,139.54Zm6.44,0a2.72,2.72,0,1,0-2.71,2.69A2.63,2.63,0,0,0,304.79,139.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8,143v-5.1l-2.52,4.25h-.46L308.28,138V143h-1v-7h.82l2.92,4.92,2.88-4.92h.81v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.52,138.48c0,1.52-1.1,2.44-2.92,2.44h-1.73V143h-1v-7h2.73C321.42,136,322.52,137,322.52,138.48Zm-1,0c0-1-.67-1.57-1.95-1.57h-1.7v3.14h1.7C320.85,140.05,321.52,139.48,321.52,138.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,136h1v6.13h3.79V143H324Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,142.17V143h-5.08v-7h4.94v.87h-3.94v2.15h3.51v.85h-3.51v2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,136.91h-2.4V136h5.79v.87H339V143h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,142.17V143H342.5v-7h4.94v.87H343.5v2.15H347v.85H343.5v2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.2,136h2.95a3.51,3.51,0,1,1,0,7H349.2Zm2.89,6.13a2.64,2.64,0,1,0,0-5.26H350.2v5.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.97,
    y: 132.66,
    width: 15.64,
    height: 14.9,
    rx: 1.18,
    transform: "translate(545.89 -265.68) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411,136.64H400.47v1h.93l.66,7.78h7.37l.65-7.78H411Zm-2.51,7.78H403l-.57-6.78h6.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.77 134.79 403.71 134.79 403.36 135.79 408.12 135.79 407.77 134.79",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.58,
    y: 132.66,
    width: 15.64,
    height: 14.9,
    rx: 1.18,
    transform: "translate(527.5 -247.29) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.26,134.79l-1.61,2v-2h-8.51v10.63h8.51v-6.26l2.78-3.42Zm-2.61,9.63h-6.51v-8.63h6.51V138l-2.73,3.37,0,1.25,1.21-.31,1.56-1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.06,
    cy: 173.61,
    r: 13.08,
    transform: "translate(-48.05 231.2) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.06,
    cy: 173.61,
    r: 11.08,
    transform: "translate(27.5 381.96) rotate(-76.72)",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,175.53v1.58h-6.34v-1.26l3.23-3.06c.75-.71.88-1.14.88-1.55,0-.65-.46-1-1.34-1A2.05,2.05,0,0,0,253,171l-1.42-.91a3.9,3.9,0,0,1,3.34-1.56c1.87,0,3.11,1,3.11,2.48a3.32,3.32,0,0,1-1.4,2.65l-1.93,1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.65,
    y: 163.79,
    width: 101.9,
    height: 19.64,
    rx: 3.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.78,
    y: 124.66,
    width: 15.64,
    height: 97.9,
    rx: 1.18,
    transform: "translate(497.2 -149.99) rotate(90)",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.27,173a3.54,3.54,0,0,1,3.71-3.58,3.46,3.46,0,0,1,2.66,1.09l-.65.63a2.59,2.59,0,0,0-2-.83,2.69,2.69,0,1,0,0,5.38,2.6,2.6,0,0,0,2-.84l.65.63a3.47,3.47,0,0,1-2.67,1.1A3.54,3.54,0,0,1,291.27,173Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,173a3.72,3.72,0,1,1,3.73,3.58A3.56,3.56,0,0,1,298.35,173Zm6.44,0a2.72,2.72,0,1,0-2.71,2.69A2.63,2.63,0,0,0,304.79,173Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8,176.54v-5.1l-2.52,4.25h-.46l-2.53-4.22v5.07h-1v-7h.82l2.92,4.92,2.88-4.92h.81v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.52,172c0,1.52-1.1,2.44-2.92,2.44h-1.73v2.12h-1v-7h2.73C321.42,169.54,322.52,170.46,322.52,172Zm-1,0c0-1-.67-1.57-1.95-1.57h-1.7v3.14h1.7C320.85,173.55,321.52,173,321.52,172Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,169.54h1v6.13h3.79v.87H324Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,175.67v.87h-5.08v-7h4.94v.87h-3.94v2.15h3.51v.85h-3.51v2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,170.41h-2.4v-.87h5.79v.87H339v6.13h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,175.67v.87H342.5v-7h4.94v.87H343.5v2.15H347v.85H343.5v2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.2,169.54h2.95a3.51,3.51,0,1,1,0,7H349.2Zm2.89,6.13a2.64,2.64,0,1,0,0-5.26H350.2v5.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.97,
    y: 166.16,
    width: 15.64,
    height: 14.9,
    rx: 1.18,
    transform: "translate(579.39 -232.18) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411,170.14H400.47v1h.93l.66,7.78h7.37l.65-7.78H411Zm-2.51,7.78H403l-.57-6.78h6.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.77 168.29 403.71 168.29 403.36 169.29 408.12 169.29 407.77 168.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.58,
    y: 166.16,
    width: 15.64,
    height: 14.9,
    rx: 1.18,
    transform: "translate(561 -213.79) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.26,168.29l-1.61,2v-2h-8.51v10.63h8.51v-6.26l2.78-3.42Zm-2.61,9.63h-6.51v-8.63h6.51v2.22l-2.73,3.37,0,1.25,1.21-.31,1.56-1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.06,
    cy: 207.11,
    r: 13.08,
    transform: "translate(-71.74 241.01) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.06,
    cy: 207.11,
    r: 11.08,
    transform: "translate(-5.11 407.76) rotate(-76.72)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18,208c0,1.42-1.09,2.71-3.48,2.71a5.71,5.71,0,0,1-3.2-.9l.75-1.48a4.08,4.08,0,0,0,2.4.75c1,0,1.57-.39,1.57-1.08s-.47-1-1.57-1h-.89v-1.28l1.73-2h-3.57v-1.56h5.87v1.26l-1.89,2.16A2.39,2.39,0,0,1,258.18,208Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.65,
    y: 197.29,
    width: 101.9,
    height: 19.64,
    rx: 3.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.78,
    y: 158.16,
    width: 15.64,
    height: 97.9,
    rx: 1.18,
    transform: "translate(530.7 -116.49) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.07,203v7h-1v-6.13H311.5V203Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.6,206.54c0-2.28,1.22-3.58,2.86-3.58s2.85,1.3,2.85,3.58-1.22,3.58-2.85,3.58S315.6,208.82,315.6,206.54Zm4.71,0c0-1.79-.76-2.69-1.85-2.69s-1.86.9-1.86,2.69.76,2.69,1.86,2.69S320.31,208.33,320.31,206.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.61,201.63h.87l-3.3,9.41h-.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.06,203v7h-1v-6.13h-1.58V203Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.59,206.54c0-2.28,1.22-3.58,2.86-3.58s2.85,1.3,2.85,3.58-1.22,3.58-2.85,3.58S329.59,208.82,329.59,206.54Zm4.71,0c0-1.79-.76-2.69-1.85-2.69s-1.86.9-1.86,2.69.76,2.69,1.86,2.69S334.3,208.33,334.3,206.54Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 397.97,
    y: 199.66,
    width: 15.64,
    height: 14.9,
    rx: 1.18,
    transform: "translate(612.89 -198.68) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411,203.64H400.47v1h.93l.66,7.78h7.37l.65-7.78H411Zm-2.51,7.78H403l-.57-6.78h6.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.77 201.79 403.71 201.79 403.36 202.79 408.12 202.79 407.77 201.79",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.58,
    y: 199.66,
    width: 15.64,
    height: 14.9,
    rx: 1.18,
    transform: "translate(594.5 -180.29) rotate(90)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.26,201.79l-1.61,2v-2h-8.51v10.63h8.51v-6.26l2.78-3.42Zm-2.61,9.63h-6.51v-8.63h6.51V205l-2.73,3.37,0,1.25,1.21-.31,1.56-1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,190.89h-184a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h184a.51.51,0,0,1,.5.5A.5.5,0,0,1,420.29,190.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,156.89h-184a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h184a.51.51,0,0,1,.5.5A.5.5,0,0,1,420.29,156.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.33,
    y: 224.39,
    width: 183.96,
    height: 71.67,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.98,
    y: 236.05,
    width: 149.36,
    height: 8.46,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.33,229.48H245.2A1.22,1.22,0,0,0,244,230.7h0a1.22,1.22,0,0,0,1.22,1.22h30.13a1.22,1.22,0,0,0,1.22-1.22h0A1.22,1.22,0,0,0,275.33,229.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.98,
    y: 258.05,
    width: 69.36,
    height: 8.46,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.33,251.48H245.2A1.22,1.22,0,0,0,244,252.7h0a1.22,1.22,0,0,0,1.22,1.22h30.13a1.22,1.22,0,0,0,1.22-1.22h0A1.22,1.22,0,0,0,275.33,251.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.98,
    y: 278.05,
    width: 116.17,
    height: 8.46,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.33,271.48H245.2A1.22,1.22,0,0,0,244,272.7h0a1.22,1.22,0,0,0,1.22,1.22h30.13a1.22,1.22,0,0,0,1.22-1.22h0A1.22,1.22,0,0,0,275.33,271.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.98,
    y: 258.05,
    width: 69.36,
    height: 8.46,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.33,251.48H325.2A1.22,1.22,0,0,0,324,252.7h0a1.22,1.22,0,0,0,1.22,1.22h30.13a1.22,1.22,0,0,0,1.22-1.22h0A1.22,1.22,0,0,0,355.33,251.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.15,
    y: 236.05,
    width: 8.46,
    height: 8.46,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.24,
    y: 258.05,
    width: 8.46,
    height: 8.46,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.88,
    y: 278.05,
    width: 8.46,
    height: 8.46,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.52,
    cy: 117.37,
    r: 2.41,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.02,
    cy: 117.37,
    r: 2.41,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.52,
    cy: 117.37,
    r: 2.41,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-623"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.59,397.58l26.56-2.32V355.7h9.33v39.56l26.66,2.32a4.59,4.59,0,0,1,4.14,4.57v3.53H104.45v-3.53A4.59,4.59,0,0,1,108.59,397.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,397.58l26.56-2.32V355.7h9.33v39.56l26.66,2.32a4.59,4.59,0,0,1,4.14,4.57v3.53H104.45v-3.53A4.59,4.59,0,0,1,108.59,397.58Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,410.07a6.11,6.11,0,1,0,6.1-6.1A6.11,6.11,0,0,0,166.68,410.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,410.07a6.1,6.1,0,1,1-6.1-6.1A6.11,6.11,0,0,1,113,410.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,326.56H142a4.13,4.13,0,0,1,4.13,4.13v32.12a0,0,0,0,1,0,0H133.54a0,0,0,0,1,0,0V330.69A4.13,4.13,0,0,1,137.67,326.56Z",
    transform: "translate(279.63 689.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,326.56H142a4.13,4.13,0,0,1,4.13,4.13v32.12a0,0,0,0,1,0,0H133.54a0,0,0,0,1,0,0V330.69A4.13,4.13,0,0,1,137.67,326.56Z",
    transform: "translate(279.63 689.37) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27,257.56s2.88,57.67,15.3,67.6H114.28s-11.84-19.64-12.73-67.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27,257.56s2.88,57.67,15.3,67.6H114.28s-11.84-19.64-12.73-67.6Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.19,320.39h58.9a5,5,0,0,1,5,5v4.56a0,0,0,0,1,0,0h-68.9a0,0,0,0,1,0,0v-4.56A5,5,0,0,1,111.19,320.39Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.57,
    y: 325.16,
    width: 74.14,
    height: 4.78,
    rx: 2.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.57,
    y: 325.16,
    width: 74.14,
    height: 4.78,
    rx: 2.01,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.22,270.18H120.5c6.24,0,10.74-5.6,10.06-12.51l-.91-9.22c-.68-6.91-6.28-12.51-12.52-12.51H95.85c-6.23,0-10.74,5.6-10.06,12.51l.91,9.22C87.38,264.58,93,270.18,99.22,270.18Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-623"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.95 408.96 176.91 407.86 178.02 388.93 170.06 390.03 168.95 408.96",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.06 390.03 178.02 388.94 177.38 399.76 169.44 400.46 170.06 390.03",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.32 401.88 195.34 402.47 200.37 384.18 192.36 383.6 187.32 401.88",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.36 383.6 200.37 384.19 197.49 394.65 189.58 393.68 192.36 383.6",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.08,393.36,189,389.21s8.43-47.58,17-64.08c-.64-.21-1.49-.48-2.54-.79-1.89-.57-4.4-1.28-7.35-2.1-20.52-5.69-62.11-16.36-62.11-16.36l19-17.73s75.68,11.54,77.25,31.48C230.94,329.22,203.08,393.36,203.08,393.36Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.08,393.36,189,389.21s8.43-47.58,17-64.08c-.64-.21-1.49-.48-2.54-.79-1.89-.57-4.4-1.28-7.35-2.1-20.52-5.69-62.11-16.36-62.11-16.36l19-17.73s75.68,11.54,77.25,31.48C230.94,329.22,203.08,393.36,203.08,393.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.27,297.64l-4-18.18-42.66.33s-4.75,28.34-1.1,35.09c6.52,12.05,41.62,6,51.89,7.15-6.14,25.11-5.54,74.18-5.54,74.18l14.67,1.12s11.29-52.88,13.57-78C197.69,302.38,183.65,302.8,169.27,297.64Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.46,402.83s0,.05,0,.06a.06.06,0,0,0,.07,0,9.42,9.42,0,0,0,2,.84,2.1,2.1,0,0,0,1.56,0,1,1,0,0,0,.5-.95.73.73,0,0,0-.27-.63,3.36,3.36,0,0,0-2.25-.06,2.94,2.94,0,0,0,1.19-1.62.7.7,0,0,0-.49-.73.93.93,0,0,0-.8,0c-1,.54-1.36,2.78-1.38,2.9h0l-.13,0A.11.11,0,0,0,196.46,402.83Zm.6-.44-.18.05c.18-.74.59-1.95,1.17-2.26a.55.55,0,0,1,.43-.06l.09,0c.25.11.28.25.27.36C198.77,401.05,197.85,402,197.06,402.39Zm0,.41c1-.32,2.52-.61,3-.27a.34.34,0,0,1,.14.31.69.69,0,0,1-.31.6C199.42,403.7,198.39,403.46,197.09,402.8Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.14 389.52 204.14 394.33 207.19 387.26 188.44 382.34 187.14 389.52",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.14 389.52 204.14 394.33 207.19 387.26 188.44 382.34 187.14 389.52",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.13,401.66l-8.69-2.42a.56.56,0,0,0-.71.36h0l-2.34,6.76a1.41,1.41,0,0,0,1,1.74c3,.8,4.54,1,8.37,2.07,2.35.64,6.92,2.15,10.27,2.53s3.64-2.94,2.25-3.4c-3.27-1.09-7.2-4.51-8.9-6.83A2.26,2.26,0,0,0,196.13,401.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.27,297.64l-4-18.18-42.66.33s-4.75,28.34-1.1,35.09c6.52,12.05,41.62,6,51.89,7.15-6.14,25.11-5.54,74.18-5.54,74.18l14.67,1.12s11.29-52.88,13.57-78C197.69,302.38,183.65,302.8,169.27,297.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.19 396.9 183.82 398.06 185.33 390.51 165.96 389.61 166.19 396.9",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.19 396.9 183.82 398.06 185.33 390.51 165.96 389.61 166.19 396.9",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71,407.88l.17,0s.17.06.2.08,0,0,0,.06h.07a9.91,9.91,0,0,0,2.09.41,2.11,2.11,0,0,0,1.53-.3,1,1,0,0,0,.29-1,.68.68,0,0,0-.4-.56,3.28,3.28,0,0,0-2.23.41,2.8,2.8,0,0,0,.79-1.84.77.77,0,0,0-.68-.61,1.22,1.22,0,0,0-.89.21c-.84.73-1,3-1,3.14h0Zm.86-.46-.17.09a4.17,4.17,0,0,1,.68-2.46.56.56,0,0,1,.41-.14h.09c.27.05.33.18.34.29A3.78,3.78,0,0,1,178.57,407.42Zm.11.4c1-.54,2.35-1.13,2.86-.89a.34.34,0,0,1,.19.28.65.65,0,0,1-.17.65C181.16,408.21,180.1,408.19,178.68,407.82Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.51,406.9l-9-.56a.56.56,0,0,0-.62.51h0L167,414a1.42,1.42,0,0,0,1.31,1.5c3.15.15,4.66.06,8.62.27,2.43.15,7.22.67,10.57.34s2.95-3.63,1.5-3.79c-3.44-.39-8-2.91-10.14-4.83A2.23,2.23,0,0,0,177.51,406.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.4,324.34c-1.89-.57-4.4-1.28-7.35-2.1.59-4.84.6-10.39-1.73-13.22-4.63-5.64-16.54-8.95-23.32-10.15-5.67-1-24.72-3-24.72-3s24.72-2.37,50,5C208.76,304.53,206.33,316.74,203.4,324.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.84 279.68 122.66 279.79 122.09 283.52 137.84 283.76 137.84 279.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.81 279.66 139.81 283.79 166.35 284.19 166.35 279.46 139.81 279.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.4,
    y: 279.87,
    width: 6.99,
    height: 5.14,
    rx: 1.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15,241.21s.24.67.69,1.75,1.12,2.73,1.94,4.52c2,4.36,4.91,9.88,7.95,12.87a8.19,8.19,0,0,0,2.7,1.88c3.23,1.24,11.35,1.47,18.6,1.4s13.45-.44,13.45-.44V257.7l-23.84-6.35s-12.56-22.68-20-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,243c.45,1.13,1.12,2.73,1.94,4.52,2,4.36,4.91,9.88,7.95,12.87,3.09-11.38-8.34-22.22-8.34-22.22Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,281.08h45.5c5.62-41.33-4.4-55.59-4.4-55.59a73.07,73.07,0,0,0-11.32-2.31,147.4,147.4,0,0,0-16.81-.36A78.05,78.05,0,0,0,123.1,224c-2,.86-4.08,9.78-2,37.54A189.31,189.31,0,0,1,121.55,281.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,281.08h45.5c5.62-41.33-4.4-55.59-4.4-55.59a73.07,73.07,0,0,0-11.32-2.31,147.4,147.4,0,0,0-16.81-.36A78.05,78.05,0,0,0,123.1,224c-2,.86-4.08,9.78-2,37.54A189.31,189.31,0,0,1,121.55,281.08Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.86 239.64 164.81 239.64 165.42 249.13 161.15 251.9 156.86 249.78 156.86 239.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,222.41,148.24,227l.54-3.83c-1.3-2.28-1.63-3.71-.53-6.36l-8.91-10.24C139.58,211.78,138.63,218.94,134.89,222.41Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,210.71l5.27,6a17.34,17.34,0,0,0-1,2.88c-2.23-.67-5-3.64-4.87-6.06A7.83,7.83,0,0,1,143,210.71Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.17,194.26c-3.23,1.64-2.31,5.23,3.74,11.45,3.18-3.2,4.51-10,2.56-12S157,192.84,154.17,194.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,198.17c-.6,7.32-1.32,11.56,1.79,15.82,4.7,6.39,14.13,4.37,16.91-2.62,2.49-6.28,3.07-17.19-3.61-21.1a10,10,0,0,0-15.09,7.9Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,201.73c-.08.59.16,1.11.55,1.17s.76-.38.84-1-.15-1.11-.53-1.17S151.33,201.15,151.2,201.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.91,202.71c-.09.59.16,1.11.54,1.17s.77-.37.86-1-.16-1.12-.54-1.17S158,202.12,157.91,202.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,202.67a21.4,21.4,0,0,0,2.09,5.46,3.43,3.43,0,0,1-2.9.11Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.68,199.35a.42.42,0,0,1-.22-.08.36.36,0,0,1,0-.5,3.42,3.42,0,0,1,3-1,.33.33,0,0,1,.27.39v0a.36.36,0,0,1-.42.27h0a2.78,2.78,0,0,0-2.38.83A.37.37,0,0,1,149.68,199.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.29,200.89a.39.39,0,0,1-.29-.24,2.75,2.75,0,0,0-1.72-1.85.36.36,0,0,1-.24-.44.34.34,0,0,1,.42-.24,3.49,3.49,0,0,1,2.21,2.32.34.34,0,0,1-.22.43h0A.39.39,0,0,1,161.29,200.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,192.16c3.22,1.66,2.28,5.25-3.81,11.42-3.17-3.22-4.46-10.06-2.48-12.05S141.67,190.73,144.48,192.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37,203.47a7,7,0,0,0,2.69,4.61c1.95,1.46,3.81-.08,4-2.39.18-2.08-.64-5.35-3-5.9A3.11,3.11,0,0,0,136.37,203.47Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.75,211.9h0a5.32,5.32,0,0,1-4.71-3,.24.24,0,0,1,.15-.33.25.25,0,0,1,.34.15,4.81,4.81,0,0,0,4.27,2.71.27.27,0,0,1,.24.29A.28.28,0,0,1,153.75,211.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,192s-2,7.15-9.09,6.71-8-5-8-5a13.65,13.65,0,0,0,1.71.37,7.36,7.36,0,0,1,.89-7c2.49-3.16,9.93-5.83,14.89-3.33a12.47,12.47,0,0,1,9.7,2.2c4.5,3.45,2.85,9.49,2.85,9.49s.7-3.71-1.44-5c0,0,1.83,8-2.64,9.56C160.85,200,161.4,192.37,152,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,211.93s2.83-5.71,4.68-5.79,4,2.89,4,2.89l-.87.59s-1.76-2.05-2.54-2.24-3.57,3.29-3.06,4.55a4,4,0,0,0,2.13,1.84l1.63-1.71,1.45.85-.9,2.26a4.19,4.19,0,0,0,3.14,0c1.29-.74,1.69-4.14,1.59-4.35a9.16,9.16,0,0,0-2.08-.63l.49-.77s2.68-.33,3.11.53-.88,6.1-2.19,6.69a7.27,7.27,0,0,1-6.43.15C145.22,215.49,143.31,213.39,144.1,211.93Z",
    style: {
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.34,257.31s25.25-.57,26.66-.71,7.4-3.52,8.67-3.66,4.68,5.2,5.1,6.47-9.54,4.64-10.53,4.5A18.23,18.23,0,0,1,186,262.7L160.23,266Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,247.2s0,0,0,0c3.75,6.08,9,12.57,14.23,12.27,5.47-.32,0-11.5-5.93-21.22-.22.47-.42.92-.58,1.36-1.33,3.73-5.39-.86-7.46-6.86A129.08,129.08,0,0,0,120.29,247.2Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.1,224c-12.91,4.65,9.74,39.6,16.78,43.2s25.54-.55,25.54-.55l-1.15-10.8s-14.65,1-17.56.25-9.84-15.63-13.82-22.67A22.49,22.49,0,0,0,123.1,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.73,220a63,63,0,0,0,12,6.24,11.81,11.81,0,0,0,0-5.67l5.9,2.94s.49,4.58-.87,6.95l-4.32-3.16-4.86,4s-9.2-3.55-10.64-8.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "212.65 416.18 206.93 416.18 206 273.1 213.58 273.1 212.65 416.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.59 273.33 213.44 296.42 212.65 416.18 206.93 416.18 206.15 296.42 206 273.33 213.59 273.33",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.59 273.33 213.44 296.67 206.15 296.67 206 273.33 213.59 273.33",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.37 416.18 267.65 416.18 257.38 273.1 264.97 273.1 273.37 416.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.38 416.18 267.65 416.18 257.88 280.21 257.38 273.33 264.97 273.33 265.38 280.21 273.38 416.18",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.38 279.87 257.88 279.87 257.38 273.33 264.97 273.33 265.38 279.87",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.93 416.18 146.21 416.18 154.61 273.1 162.2 273.1 151.93 416.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.2 273.33 161.7 280.21 151.92 416.18 146.21 416.18 154.2 280.21 154.61 273.33 162.2 273.33",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.61 273.33 162.2 273.33 161.7 279.87 154.2 279.87 154.61 273.33",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,269.52H271a0,0,0,0,1,0,0v5a2.16,2.16,0,0,1-2.16,2.16H150.76a2.16,2.16,0,0,1-2.16-2.16v-5A0,0,0,0,1,148.6,269.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,269.52H271a0,0,0,0,1,0,0v5a2.16,2.16,0,0,1-2.16,2.16H150.76a2.16,2.16,0,0,1-2.16-2.16v-5A0,0,0,0,1,148.6,269.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.6,
    y: 269.52,
    width: 122.38,
    height: 3.58,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53,270.45H145.05a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H274.53a2,2,0,0,1,2,2h0A2,2,0,0,1,274.53,270.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53,270.45H145.05a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H274.53a2,2,0,0,1,2,2h0A2,2,0,0,1,274.53,270.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.16,262.28v2.34c0,.7-1.21,1.2-1.9,1.2H177.54c-.7,0-1.82-.5-1.82-1.2v-2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.16,262.28v2.34c0,.7-1.21,1.2-1.9,1.2H177.54c-.7,0-1.82-.5-1.82-1.2v-2.34Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.16,262.28v2.34c0,.7-1.21,1.2-1.9,1.2H196.17c-.7,0-1.86-.5-1.86-1.2v-2.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,233.51l-6.52,29.65a2.3,2.3,0,0,1-2.11,1.77H198.72a1.54,1.54,0,0,1-1.33-2l6.5-29.33a2,2,0,0,1,2.12-1.45h35.58C242.55,232.17,243.15,232.54,242.94,233.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,233.51l-6.52,29.65a2.3,2.3,0,0,1-2.11,1.77H198.72a1.54,1.54,0,0,1-1.33-2l6.5-29.33a2,2,0,0,1,2.12-1.45h35.58C242.55,232.17,243.15,232.54,242.94,233.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,233.51l-6.52,29.65a2.3,2.3,0,0,1-2.11,1.77H199.93a1.55,1.55,0,0,1-1.34-2l6.51-29.33a2,2,0,0,1,2.12-1.45h34.37C242.55,232.17,243.15,232.54,242.94,233.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,252.51c1.66,0,3.36-1.78,3.79-4s-.56-4-2.23-4a2.67,2.67,0,0,0-.92.17,5.07,5.07,0,0,1-2.82,3.62,1.67,1.67,0,0,0,0,.18C219.34,250.73,220.34,252.51,222,252.51Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedstepsRafiki);
export default __webpack_public_path__ + "static/media/Completed steps-rafiki.f23d8b8756801f650a2af948c8ff8257.svg";
export { ForwardRef as ReactComponent };